module.exports = __webpack_public_path__ + "static/images/van.ynC07kO.svg";